<template>
  <div>
    <a
      href="javascript:;"
      class="
                btn btn-icon btn-clean btn-lg
                w-40px
                h-40px
                btn-toggle-usuario
            "
      :class="{ receber: fgModoPR == 'R', pagar: fgModoPR == 'P' }"
      id="kt_quick_user_toggle"
      data-toggle="tooltip"
      data-placement="right"
      data-container="body"
      data-boundary="window"
      title=""
      data-original-title="User Profile"
    >
      <span class="symbol symbol-30 symbol-lg-40">
        <span class="svg-icon svg-icon-xl">
          <!--begin::Svg Icon-->
          <inline-svg src="media/svg/icons/General/User.svg" />
          <!--end::Svg Icon-->
        </span>
        <!--<span class="symbol-label font-size-h5 font-weight-bold">S</span>-->
      </span>
    </a>

    <div
      id="kt_quick_user"
      ref="kt_quick_user"
      class="offcanvas offcanvas-left p-10"
    >
      <!--begin::Header-->
      <div
        class="
                    offcanvas-header
                    d-flex
                    align-items-center
                    justify-content-between
                    pb-5
                "
      >
        <h3 class="font-weight-bold m-0">
          Perfil do Usuário
          <small class="text-muted font-size-sm ml-2">0 mensagens</small>
        </h3>
        <a
          href="javascript:;"
          class="btn btn-xs btn-icon btn-light"
          :class="{
            'btn-hover-primary': fgModoPR == 'R',
            'btn-hover-danger': fgModoPR == 'P'
          }"
          id="kt_quick_user_close"
        >
          <i class="ki ki-close icon-xs text-muted"></i>
        </a>
      </div>
      <!--end::Header-->

      <!--begin::Content-->
      <perfect-scrollbar
        class="offcanvas-content pr-5 mr-n5 scroll"
        style="max-height: 90vh; position: relative"
      >
        <!--begin::Header-->
        <div class="d-flex align-items-center mt-5">
          <div class="symbol symbol-100 mr-5">
            <img class="symbol-label" :src="picture" alt="" />
            <i class="symbol-badge bg-success"></i>
          </div>
          <div class="d-flex flex-column">
            <a
              href="javascript:;"
              class="font-weight-bold font-size-h5 text-dark-75"
              :class="{
                'text-hover-primary': fgModoPR == 'R',
                'text-hover-danger': fgModoPR == 'P'
              }"
            >
              {{ this.currentUser.nome }}
            </a>
            <div class="text-muted mt-1">Empresa Parceira</div>
            <div class="navi mt-2">
              <a href="javascript:;" class="navi-item">
                <span class="navi-link p-0 pb-2">
                  <span class="navi-icon mr-1">
                    <span
                      class="svg-icon svg-icon-lg"
                      :class="{
                        'svg-icon-primary': fgModoPR == 'R',
                        'svg-icon-danger': fgModoPR == 'P'
                      }"
                    >
                      <!--begin::Svg Icon-->
                      <inline-svg
                        src="media/svg/icons/Communication/Mail-notification.svg"
                      />
                      <!--end::Svg Icon-->
                    </span>
                  </span>
                  <span
                    class="navi-text text-muted"
                    :class="{
                      'text-hover-primary': fgModoPR == 'R',
                      'text-hover-danger': fgModoPR == 'P'
                    }"
                    style="word-break: break-all"
                  >
                    {{ this.currentUser.email }}
                  </span>
                </span>
              </a>
            </div>
            <button
              class="btn btn-bold"
              :class="{
                'btn-light-primary': fgModoPR == 'R',
                'btn-light-danger': fgModoPR == 'P'
              }"
              @click="onLogout"
            >
              Sair
            </button>
          </div>
        </div>
        <!--end::Header-->
        <div class="separator separator-dashed mt-8 mb-5"></div>
        <div class="navi navi-spacer-x-0 p-0">
          <!--<router-link to="/builder" @click.native="closeOffcanvas" href="javascript:;" class="navi-item">
                        <div class="navi-link">
                            <div class="symbol symbol-40 bg-light mr-3">
                                <div class="symbol-label">
                                    <span class="svg-icon svg-icon-md svg-icon-success">
                                        <inline-svg src="media/svg/icons/General/Notification2.svg" />
                                    </span>
                                </div>
                            </div>
                            <div class="navi-text">
                                <div class="font-weight-bold">Meu Perfil</div>
                                <div class="text-muted">
                                    Configurações da conta e mais
                                    <span class="label label-light-danger label-inline font-weight-bold">
                                        update
                                    </span>
                                </div>
                            </div>
                        </div>
                    </router-link>-->
          <router-link
            v-if="fgMaster || fgSecurity"
            to="/usuarios"
            @click.native="closeOffcanvas"
            href="javascript:;"
            class="navi-item"
            :class="{
              receber: fgModoPR == 'R',
              pagar: fgModoPR == 'P'
            }"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span
                    class="
                                            svg-icon
                                            svg-icon-md
                                            svg-icon-warning
                                        "
                  >
                    <inline-svg src="media/svg/icons/Shopping/Ticket.svg" />
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">Convidar</div>
                <div class="text-muted">
                  Usuários participantes do dashboard
                </div>
              </div>
            </div>
          </router-link>
          <router-link
            v-if="fgMaster || fgSecurity"
            to="/logAcesso"
            @click.native="closeOffcanvas"
            href="javascript:;"
            class="navi-item"
            :class="{
              receber: fgModoPR == 'R',
              pagar: fgModoPR == 'P'
            }"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span
                    class="
                                            svg-icon
                                            svg-icon-md
                                            svg-icon-warning
                                        "
                  >
                    <inline-svg src="media/svg/icons/Files/Folder-check.svg" />
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">
                  Log de Acesso
                </div>
                <div class="text-muted">
                  Visualize quais usuários estão acessando o sistema
                </div>
              </div>
            </div>
          </router-link>
          <router-link
            to="/trocaSenha"
            @click.native="closeOffcanvas"
            href="javascript:;"
            class="navi-item"
          >
            <div
              class="navi-link"
              :class="{
                receber: fgModoPR == 'R',
                pagar: fgModoPR == 'P'
              }"
            >
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span
                    class="
                                            svg-icon
                                            svg-icon-md
                                            svg-icon-warning
                                        "
                  >
                    <inline-svg src="media/svg/icons/Shopping/Safe.svg" />
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">Trocar Senha</div>
                <div class="text-muted">
                  Alteração da sua senha pessoal
                </div>
              </div>
            </div>
          </router-link>
          <router-link
            v-if="fgMaster || fgConfiguracoes"
            to="/configuracoes"
            @click.native="closeOffcanvas"
            href="javascript:;"
            class="navi-item"
            :class="{
              receber: fgModoPR == 'R',
              pagar: fgModoPR == 'P'
            }"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span
                    class="
                                            svg-icon
                                            svg-icon-md
                                            svg-icon-warning
                                        "
                  >
                    <inline-svg src="media/svg/icons/Code/Info-circle.svg" />
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">
                  Configurações
                </div>
                <div class="text-muted">
                  Visualize e modifique as configurações do sistema
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <!--<router-link to="/builder" @click.native="closeOffcanvas" href="#" class="navi-item">
                        <div class="navi-link">
                            <div class="symbol symbol-40 bg-light mr-3">
                                <div class="symbol-label">
                                    <span class="svg-icon svg-icon-md svg-icon-danger">
                                        <inline-svg src="media/svg/icons/Files/Selected-file.svg" />
                                    </span>
                                </div>
                            </div>
                            <div class="navi-text">
                                <div class="font-weight-bold">My Activities</div>
                                <div class="text-muted">Logs and notifications</div>
                            </div>
                        </div>
                    </router-link>
                    <router-link to="/builder" @click.native="closeOffcanvas" href="#" class="navi-item">
                        <div class="navi-link">
                            <div class="symbol symbol-40 bg-light mr-3">
                                <div class="symbol-label">
                                    <span class="svg-icon svg-icon-md svg-icon-primary">
                                        <inline-svg src="media/svg/icons/Communication/Mail-opened.svg" />
                                    </span>
                                </div>
                            </div>
                            <div class="navi-text">
                                <div class="font-weight-bold">My Tasks</div>
                                <div class="text-muted">latest tasks and projects</div>
                            </div>
                        </div>
                    </router-link>
                </div>
                <div class="separator separator-dashed my-7"></div>
                <div>
                    <h5 class="mb-5">Recent Notifications</h5>
                    <template v-for="(item, i) in list">
                        <div class="d-flex align-items-center rounded p-5 gutter-b" v-bind:class="`bg-light-${item.type}`" v-bind:key="i">
                            <span class="svg-icon mr-5" v-bind:class="`svg-icon-${item.type}`">
                                <span class="svg-icon svg-icon-lg">
                                    <inline-svg :src="item.svg" />
                                </span>
                            </span>
                            <div class="d-flex flex-column flex-grow-1 mr-2">
                                <a href="#" class="font-weight-normal text-dark-75 text-hover-primary font-size-lg mb-1">
                                    {{ item.title }}
                                </a>
                                <span class="text-muted font-size-sm">
                                    {{ item.desc }}
                                </span>
                            </div>
                            <span class="font-weight-bolder py-1 font-size-lg" v-bind:class="`text-${item.type}`">
                                {{ item.alt }}
                            </span>
                        </div>
                    </template>
                </div>-->
      </perfect-scrollbar>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
}

.btn.btn-clean.receber:hover:not(.btn-text):not(:disabled):not(.disabled) {
  color: #1bc5bd;
}

.btn.btn-clean.pagar:hover:not(.btn-text):not(:disabled):not(.disabled) {
  color: #f64e60;
}

.navi .navi-item .navi-link.receber:hover .navi-text {
  color: #1bc5bd;
}

.navi .navi-item .navi-link.pagar:hover .navi-text {
  color: #f64e60;
}
</style>

<script>
import { mapGetters } from "vuex";
import { LOGOUT } from "@/core/services/store/auth.module";
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import KTOffcanvas from "@/assets/js/components/offcanvas.js";

export default {
  name: "KTQuickUser",
  data() {
    return {
      list: [
        {
          title: "Another purpose persuade",
          desc: "Due in 2 Days",
          alt: "+28%",
          svg: "media/svg/icons/Home/Library.svg",
          type: "warning"
        },
        {
          title: "Would be to people",
          desc: "Due in 2 Days",
          alt: "+50%",
          svg: "media/svg/icons/Communication/Write.svg",
          type: "success"
        },
        {
          title: "Purpose would be to persuade",
          desc: "Due in 2 Days",
          alt: "-27%",
          svg: "media/svg/icons/Communication/Group-chat.svg",
          type: "danger"
        },
        {
          title: "The best product",
          desc: "Due in 2 Days",
          alt: "+8%",
          svg: "media/svg/icons/General/Attachment2.svg",
          type: "info"
        }
      ]
    };
  },
  mounted() {
    // Init Quick User Panel
    KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
  },
  methods: {
    onLogout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    },
    closeOffcanvas() {
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    }
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "fgModoPR",
      "fgMaster",
      "fgSecurity",
      "fgConfiguracoes"
    ]),
    picture() {
      return process.env.BASE_URL + "media/users/default.jpg";
    }
  }
};
</script>
